import { Action, ThunkDispatch } from '@reduxjs/toolkit'
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { IApplicationState } from 'Store/types'

export type ThunkAppDispatch = ThunkDispatch<IApplicationState, void, Action>
export const useAppDispatch = () => useDispatch<ThunkAppDispatch>()
export const useAppSelector: TypedUseSelectorHook<IApplicationState> = useSelector
